export default {
  tiles: [
    {
      index: 1,
      backgroundColor: '#005FB9',
      textColor: 'white',
      entityName: 'student_loan_refinance_smorg',
      eyebrow: 'Home sweet home',
      eyebrowColor: 'white',
      description:
        'Check out tips from our experts on landing your first home.',
      descriptionImage: '',
      descriptionItalic: '',
      buttonText: "Let's do this",
      buttonUrl:
        'https://www.nerdwallet.com/article/mortgages/tips-for-first-time-home-buyers',
      buttonColor: '',
      quoteText: '',
      quoteColor: '',
      quoteSize: '',
      imageUrl: '',
      imageAlt: '',
      boxUrl: false,
      imageLinkUrl: '',
    },
    {
      index: 2,
      backgroundColor: '#E3FAF2',
      textColor: 'neutral-darkest',
      entityName: 'spending_budget_smorg',
      eyebrow: 'Make an impact',
      eyebrowColor: 'neutral-darker',
      description:
        'Learn how to invest in Black-owned businesses and green companies.',
      descriptionImage: '',
      descriptionItalic: '',
      buttonText: 'Show me more',
      buttonUrl:
        'https://www.nerdwallet.com/article/investing/socially-responsible-investing',
      buttonColor: '',
      quoteText: '',
      quoteColor: 'neutral-darkest',
      quoteSize: '2',
      imageUrl: '',
      imageAlt: '',
      boxUrl: false,
      imageLinkUrl: '',
    },
    {
      index: 3,
      backgroundColor: '#E3FAF2',
      textColor: '',
      entityName: 'life_insurance_smorg',
      eyebrow: 'Moving on up',
      eyebrowColor: 'neutral-darker',
      description: 'Build your credit with this simple recipe.',
      descriptionImage: '',
      descriptionItalic: '',
      buttonText: 'Yes please',
      buttonUrl:
        'https://www.nerdwallet.com/article/finance/simple-way-manage-credit-score ',
      buttonColor: '',
      quoteText: '',
      quoteColor: 'neutral-darker',
      quoteSize: '1',
      imageUrl: '',
      imageAlt: '',
      boxUrl: false,
      imageLinkUrl: '',
    },
    {
      index: 4,
      backgroundColor: '#F5F5F5',
      textColor: 'neutral-darkest',
      entityName: 'podcast_guide_smorg',
      eyebrow: 'Worth A Listen',
      eyebrowColor: 'neutral-darker',
      description:
        'Have a money goal? Turn to our SmartMoney podcast for hacks, how-tos and more.',
      descriptionImage: '',
      descriptionItalic: '',
      buttonText: 'Tune in',
      buttonUrl:
        'https://www.nerdwallet.com/blog/podcast/?trk_copy=hpsmartmoneypodcast',
      buttonColor: '',
      quoteText: '',
      quoteColor: '',
      quoteSize: '',
      imageUrl: '',
      imageAlt: '',
      boxUrl: false,
      imageLinkUrl: '',
    },
    {
      index: 5,
      backgroundColor: '#EEF7FF',
      textColor: 'neutral-darkest',
      entityName: 'investing_guide_smorg',
      eyebrow: 'Start saving',
      eyebrowColor: 'neutral-darker',
      description:
        "Working from home? Here's how to spend less on car insurance.",
      descriptionImage: '',
      descriptionItalic: '',
      buttonText: 'Get answers',
      buttonUrl:
        'https://www.nerdwallet.com/article/insurance/pay-per-mile-car-insurance',
      buttonColor: '',
      quoteText: '',
      quoteColor: '',
      quoteSize: '',
      imageUrl: '',
      imageAlt: '',
      boxUrl: false,
      imageLinkUrl: '',
    },
    {
      index: 6,
      backgroundColor: '#E3FAF2',
      textColor: 'neutral-darkest',
      entityName: 'banking_guide_smorg',
      eyebrow: 'How interesting...',
      eyebrowColor: 'neutral-darker',
      description: 'Discover banks that pay the highest interest rates on CDs.',
      descriptionImage: '',
      descriptionItalic: '',
      buttonText: 'Yay free money',
      buttonUrl:
        'https://www.nerdwallet.com/best/banking/cd-rates?trk_copy=hpbestcds',
      buttonColor: '',
      quoteText: '',
      quoteColor: '',
      quoteSize: '',
      imageUrl: '',
      imageAlt: '',
      boxUrl: false,
      imageLinkUrl: '',
    },
  ],
};
